<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <product-select
            :value="productSelectValue"
            @input="handleProductSelectInput($event)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <number-input v-model="form.quantity" :alias="'Quantidade'" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <number-input v-model="form.price" :decimalPlaces='4' :alias="'Custo'" />
      </div>
      <div class="col-md-2">
        <number-input :value="subTotal" :alias="'SubTotal'" :disabled="true"/>
      </div>
      <div class="col-md-2">
        <number-input v-model="form.discount" :alias="'Desconto'" />
      </div>
      <div class="col-md-2">
        <number-input :value="productTotal" :alias="'Total'" :disabled="true" />
      </div>
    </div>
    <hr />
    <div class="row" v-show="showTaxes">
      <div class="col-md-2">
        <number-input v-model="form.icms_calc_base" :alias="'Base Calc. Icms'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.icms" :alias="'Icms'" />
      </div>
      <div class="col-md-2">
        <number-input
          v-model="form.icms_st_calc_base"
          :alias="'Base Calc. Icms St'"
        />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.icms_st" :alias="'Icms St'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.ipi_calc_base" :alias="'Base Calc. Ipi'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.ipi" :alias="'Ipi'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.insurance" :alias="'Seguro'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.shipping" :alias="'Frete'" />
      </div>
      <div class="col-md-2">
        <number-input v-model="form.expenses" :alias="'Outras Desp.'" />
      </div>
    </div>
    <div class="row" v-show="showInfo">
      <div class="col-md-2">
        <text-input
          v-model="form.vendor_code"
          :alias="'Cod. Fornecedor'"
        ></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.gtin" :alias="'Cod. EAN'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.unit" :alias="'Unidade'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.cfop" :alias="'CFOP'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.cst" :alias="'CST'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.csosn" :alias="'CSOSN'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.ncm" :alias="'NCM'"></text-input>
      </div>
      <div class="col-md-2">
        <text-input v-model="form.cest" :alias="'CEST'"></text-input>
      </div>

      <div class="col-md-2">
        <!-- <div class="form-group">
          <label class="control-label">&nbsp;</label><br />
          <button
            class="btn btn-success btn-block btn-sm"
            @click="handleAddProduct()"
          >
            Adicionar
          </button>
        </div> -->
      </div>
    </div>

    <div class="row">
      <div class="col-md-10">
        <button
          class="btn btn-sm btn-light"
          @click="showTaxes = !showTaxes"
          tabindex="-1"
        >
          <i
            :class="['text-info fas', showTaxes ? 'fa-eye-slash' : 'fa-eye']"
          ></i>
          Impostos
        </button>
        <button class="btn btn-sm btn-light ml-2" @click="showInfo = !showInfo">
          <i
            :class="['text-info fas', showInfo ? 'fa-eye-slash' : 'fa-eye']"
            tabindex="-1"
          ></i>
          Informações fiscais
        </button>
      </div>
      <div class="col-md-2 text-right">
        <div class="form-group">
          <button
            class="btn btn-success btn-block btn-sm"
            @click="handleAddProduct()"
          >
            Adicionar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productSelect from "@/components/product/inputs/ProductSelect";

export default {
  components: { productSelect },

  data: () => ({
    form: {
      
    },

    baseForm: {
      product_base: null,
      product_variant: null,
      product_company: null,
      vendor_code: null,
      gtin: null,
      unit: null,
      raw_quantity : 0,
      quantity_multipler : 1,
      quantity: 0,
      raw_price : 0,
      price: 0,
      discount: 0,
      icms_calc_base: 0,
      icms_aliquot: 0,
      icms: 0,
      icms_st_calc_base: 0,
      icms_st_aliquot: 0,
      icms_st: 0,
      ipi_calc_base: 0,
      ipi_aliquot: 0,
      ipi: 0,
      shipping: 0,
      expenses: 0,
      insurance: 0,
      cfop: null,
      origin: null,
      cst: null,
      csosn: null,
      ncm: null,
      cest: null,
    },

    showTaxes: false,
    showInfo: false,
  }),

  created() {
    this.resetForm();
  },

  computed: {
    subTotal() {
      return this.form.price * this.form.quantity  
    },

    productTotal() {
      return this.subTotal - this.form.discount 
    },

    productSelectValue() {
      if (!this.form.product_base) {
        return null;
      }

      let productSelectValue = this.form.product_base;

      productSelectValue.product_variant = this.form.product_variant;
      productSelectValue.product_variant.product_company = this.form.product_company;

      return productSelectValue;
    },
  },

  methods: {
    handleAddProduct() {
      if (this.validate()) {
        this.$emit("input", this.form);

        this.resetForm();
      }
    },

    validate() {
      if (!this.form.product_base) {
        return false
      }

      return true
    },

    resetForm() {
      this.form = JSON.parse(JSON.stringify(this.baseForm));
    },

    setPurchaseProduct(purchaseProduct) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(purchaseProduct));
    },

    handleProductSelectInput(product_base) {
      if (product_base !== null) {
        this.form.product_base = product_base;
        this.form.product_variant = product_base.product_variant;
        this.form.product_company =
          product_base.product_variant.product_company;
      } else {
        this.form.product_base = null;
        this.form.product_variant = null;
        this.form.product_company = null;
      }
    },
  },
};
</script>

<style>
</style>